import type { AccessAction } from "../types";

interface AccessActionTranslationKeys {
  title: string;
  informationTitle: string;
  informationDescription: string;
  informationFollowUp: string;
}

export function getAccessActionTranslationKeys(
  action: AccessAction,
): AccessActionTranslationKeys {
  switch (action) {
    case "enable":
      return {
        title: "users.list.accessManagement.drawer.enable.title",
        informationTitle:
          "users.list.accessManagement.drawer.enable.information.title",
        informationDescription:
          "users.list.accessManagement.drawer.enable.information.description",
        informationFollowUp:
          "users.list.accessManagement.drawer.enable.information.followUp",
      };
    case "disable":
      return {
        title: "users.list.accessManagement.drawer.disable.title",
        informationTitle:
          "users.list.accessManagement.drawer.disable.information.title",
        informationDescription:
          "users.list.accessManagement.drawer.disable.information.description",
        informationFollowUp:
          "users.list.accessManagement.drawer.disable.information.followUp",
      };
  }
}
